import React from 'react';
import MetricCard from './MetricCard';

export default function MetricGrid({ metrics = [] }) {
  return (
    <div className="wt-metric-grid">
      {metrics.map((metric) => (
        <MetricCard key={metric.id || metric.label} {...metric} />
      ))}
    </div>
  );
}
